<div class="controls" [class.controls--collapsed]="collapsed()">
    <button
        type="button"
        class="controls__button"
        aria-controls="shell-nav"
        [attr.aria-label]="collapsed() ? 'Развернуть меню разделов' : 'Свернуть меню разделов'"
        [attr.aria-expanded]="!collapsed()"
        (click)="navToggled.emit()"
    >
        <app-nav-icon name="menu" />
    </button>

    <span
        class="controls__user"
        [matTooltip]="userHint()"
        [matTooltipDisabled]="!collapsed()"
        matTooltipPosition="right"
    >
        <span class="controls__name">{{ userName() }}</span>
        @if (roleName(); as role) {
            <span class="controls__role">{{ role }}</span>
        }
    </span>

    <button
        type="button"
        class="controls__button"
        aria-label="Выйти из приложения"
        matTooltip="Выйти"
        matTooltipPosition="right"
        (click)="logoutRequested.emit()"
    >
        <app-nav-icon name="logout" />
    </button>
</div>
